const SETTINGS_API = process.env.REACT_APP_SETTINGS_API_BASE_URI
const SETTINGS_CACHE: Record<string, string> = {} // Cache to store connect URL

const fetchData = async (url: string, accessToken: string) => {
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      }
    })

    if (!response.ok) throw new Error(`Error ${response.status}: ${response.statusText}`)

    return await response.json()
  } catch (error) {
    console.error(`Fetch failed: ${url}`, error)
    return null
  }
}

export const getSettings = async (accessToken: string, projectLocation: string): Promise<any | null> => {
  if (SETTINGS_CACHE[projectLocation]) return SETTINGS_CACHE[projectLocation] // Return cached value if available

  const data = await fetchData(`${SETTINGS_API}settings/${projectLocation}/all`, accessToken)
  if (data) {
    SETTINGS_CACHE[projectLocation] = data // Store in cache to avoid redundant API calls
  } else {
    console.warn(`Failed to retrieve Connect URL for ${projectLocation}`)
  }
  return data
}
